let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8h9es")).then(() => parcelRequire('5Ml5D'));